import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useTab(defaultValue = '') {
  const [activeTab, setActiveTab] = useState<string>(defaultValue);
  const [searchParams, setSearchParams] = useSearchParams();

  const onTabChange = (newValue: string) => {
    setSearchParams({ status: newValue });
  };

  useEffect(() => {
    let activeTab = searchParams.get('status');
    if (activeTab) {
      setActiveTab(activeTab);
    } else {
      // setSearchParams({ status: defaultValue });
      setActiveTab(defaultValue);
    }
  }, [searchParams]);
  return { onTabChange, activeTab };
}
